/**
 * عکس‌های مشکوک و حکمِ تستِ سمتِ سرور — WHOSUP-300، مایگریشن 0161.
 *
 * دو تصمیم این‌جاست تا با `npm test` آزموده شوند:
 *
 * ۱. **آستانه‌ی مشکوک** — در ۷ روزِ گذشته دست‌کم ۳ کاربرِ مختلف یا ۵ نشستِ
 *    مختلف. همین عددها در `suspect_images()` (SQL) هم سفت نوشته شده‌اند، چون
 *    کرالر از همان تابع می‌خواند؛ تستِ RLS مرزشان را روی دیتابیس می‌سنجد.
 *    ⚠ پرویز این آستانه را خودش بالا برده؛ کمترش نکنید.
 * ۲. **حکم** — از جوابِ تستِ سرور: خراب / سالم / «سالم ولی منبع نمی‌گذارد
 *    سایتِ دیگری نشانش دهد». کرالر همین قاعده را اجرا و در `image_checks`
 *    می‌نویسد.
 */

export const SUSPECT_WINDOW_DAYS = 7;
export const SUSPECT_MIN_USERS = 3;
export const SUSPECT_MIN_SESSIONS = 5;

export function isSuspectImage(c: { users: number; sessions: number }): boolean {
  return c.users >= SUSPECT_MIN_USERS || c.sessions >= SUSPECT_MIN_SESSIONS;
}

export type ImageVerdict = 'broken' | 'ok' | 'hotlink_blocked';

export interface ImageProbe {
  /** درخواستِ بی‌Referer؛ null یعنی جوابی نیامد (دامنه نیست، تایم‌اوت). */
  status: number | null;
  contentType: string | null;
  /** همان درخواست با Referer ِ سایتِ ما؛ نبودش یعنی این آزمون انجام نشد. */
  withRefererStatus?: number | null;
}

const ok2xx = (s: number | null | undefined): boolean => s != null && s >= 200 && s < 300;

export function imageVerdict(p: ImageProbe): ImageVerdict {
  // جوابِ موفق ولی غیرِ عکس (صفحه‌ی HTMLِ «پیدا نشد») هم خراب است.
  const isImage = (p.contentType ?? '').trim().toLowerCase().startsWith('image/');
  if (!ok2xx(p.status) || !isImage) return 'broken';
  if (p.withRefererStatus !== undefined && !ok2xx(p.withRefererStatus)) return 'hotlink_blocked';
  return 'ok';
}

export const VERDICT_LABEL: Record<ImageVerdict, string> = {
  broken: 'خراب',
  ok: 'سالم',
  hotlink_blocked: 'سالم، ولی منبع نمی‌گذارد سایتِ دیگری نشانش دهد',
};
